import { render, staticRenderFns } from "./products-table.vue?vue&type=template&id=702c1b0e"
import script from "./products-table.vue?vue&type=script&lang=js"
export * from "./products-table.vue?vue&type=script&lang=js"
import style0 from "./products-table.vue?vue&type=style&index=0&id=702c1b0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports